export default __webpack_public_path__ + "static/media/desk-clean1.6fefe816.png";